import { Box } from "@mui/material";
import {
  GridColDef,
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ETheme } from "../../../shared/enums/user/ETheme";
import { EditIcon, TrashIcon } from "../../../shared/icons/Icons";
import { darkTheme, lightTheme } from "../../../shared/mui/theme";
import { RootState } from "../../../store/store";
import { IEmailTemplate } from "../../../shared/interfaces/email-template/IEmailTemplate";

export const useEmailTemplateColumns = (
  setSelectedTemplate: (template: IEmailTemplate) => void,
  setShowDeleteModal: (show: boolean) => void,
  hideActionColumn = false,
): GridColDef[] => {
  const { t } = useTranslation();
  const { userData } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  return [
    { field: "id", headerName: t("general.id"), width: 80 },
    {
      field: "name",
      headerName: t("emails.name"),
      flex: 1,
      minWidth: 250,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div
          style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          onClick={() => {
            navigate(`/email-template/update/${params?.row?.id}`);
            setSelectedTemplate(params?.row);
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "category",
      headerName: t("emails.category"),
      width: 150,
    },
    {
      field: "language",
      headerName: t("emails.language"),
      width: 150,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {t(`language.${params.value}`)}
        </div>
      ),
    },
    {
      field: "active",
      headerName: t("general.isActive"),
      width: 100,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          {t(`general.${params.value}`)}
        </div>
      ),
    },
    {
      field: "actions",
      headerName: t("general.action"),
      width: 150,
      sortable: false,
      renderCell: (
        params: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>,
      ) => (
        <Box
          sx={{
            display: hideActionColumn ? "none" : "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {/* Edit or View Icon */}
          <span
            style={{ cursor: "pointer", display: "flex" }}
            onClick={() => {
              navigate(`/email-template/update/${params?.row?.id}`);
            }}
          >
            <EditIcon
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>

          <span
            style={{ cursor: "pointer" }}
            className={"ms-3 d-flex"}
            onClick={() => {
              setSelectedTemplate(params.row);
              setShowDeleteModal(true);
            }}
          >
            <TrashIcon
              fill={
                userData?.theme === ETheme.LIGHT
                  ? lightTheme.palette.text.primary
                  : darkTheme.palette.text.primary
              }
            />
          </span>
        </Box>
      ),
    },
  ];
};
